/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Memory_Limit_ReachedInputs */



/**
* | output |
* | --- |
* | "You have reached the maximum of {max} entries. Delete one to make room." |
*
* @param {Memory_Limit_ReachedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_limit_reached = /** @type {((inputs: Memory_Limit_ReachedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Limit_ReachedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Du hast das Maximum von ${i?.max} Einträgen erreicht. Lösche einen, um Platz zu schaffen.`)
	return /** @type {LocalizedString} */ (`You have reached the maximum of ${i?.max} entries. Delete one to make room.`)
});